import type { AxiosRequestConfig } from 'axios';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';

export interface PostingTemplateError {
  id: number;
  posting_template_id: number;
  error_message: string;
  help_message?: string | null;
  severity: string;
  error_source?: string | null;
  created_at?: string;
  updated_at?: string;
}

type PostingTemplateErrorApiEnvelope = {
  data?: PostingTemplateError[];
  total?: number;
};

type PostingTemplateErrorRequestOptions = Pick<AxiosRequestConfig, 'signal' | 'operationRequirement'>;

export async function getPostingTemplateErrors(
  scope: RequestScope,
  args: {
    subscriptionId: number;
    postingTemplateId: number;
  },
  options: PostingTemplateErrorRequestOptions = {}
): Promise<ChannelApiResponse<PostingTemplateError[]>> {
  try {
    if (!args.subscriptionId || args.subscriptionId < 1) {
      throw new Error('Valid subscriptionId is required');
    }
    if (!args.postingTemplateId || args.postingTemplateId < 1) {
      throw new Error('Valid postingTemplateId is required');
    }

    const res = await scopedChannelApi(scope).get<PostingTemplateErrorApiEnvelope>(`atts/posting_template_error/${args.postingTemplateId}`, {
      ...options,
      headers: {
        'x-astur-subscription-id': args.subscriptionId.toString(),
      },
      params: {
        limit: 100,
      },
    });

    const errors: PostingTemplateError[] = Array.isArray(res.data?.data) ? res.data!.data : [];
    return { data: errors, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
